<template>
  <setting-account-form
    @submit="register"
  />
</template>

<style>
.certification-number-length {
  width: 5em;
}
</style>

<script>
import SettingAccountForm from '@/components/organisms/SettingAccountForm'
import Indicator from '@/lib/indicator'

export default {
  components: {
    SettingAccountForm
  },
  methods: {
    register (value) {
      Indicator.emitShow()
      this.$http.secured.post('/account/edit/settings/staff', value).then(response => {
        this.$toasted.global.success({ message: 'ID／仮PWを送信しました。' })
        this.$router.push({ name: 'settingAccounts' })
      }).finally(() => {
        Indicator.emitHide()
      })
    }
  }
}
</script>
